import './SkeletonLoading.css';

// Skeleton loader component
export const SkeletonCard = ({ height }) => (
  <div
    className="stat-card skeleton-card"
    style={height ? { height } : undefined}
  >
    <div className="skeleton-icon"></div>
    <div className="skeleton-content">
    <div className="skeleton-title"></div>
    <div className="skeleton-value"></div>
    </div>
  </div>
  );

export const SkeletonChart = ({ height }) => (
    <div className="chart-card skeleton-chart" style={height ? { height } : undefined}>
      <div className="skeleton-chart-header"></div>
      <div className="skeleton-chart-body"></div>
    </div>
  );

export  const SkeletonMilestone = () => (
    <div className="milestone-card skeleton-milestone">
      <div className="skeleton-milestone-content"></div>
    </div>
  );

